function removeRecaptcha() {
  document.querySelectorAll("script[data-recaptcha-api]").forEach(function(s) {
    s.remove();
  });
  document.querySelectorAll(".grecaptcha-badge").forEach(function(b) {
    b.remove();
  });
  try {
    delete window.grecaptcha;
  } catch (e) {
    window.grecaptcha = undefined;
  }
  try {
    delete window.___grecaptcha_cfg;
  } catch (e) {
    window.___grecaptcha_cfg = undefined;
  }
}

function loadRecaptchaApi(siteKey) {
  var script = document.createElement("script");
  script.src =
    "https://www.google.com/recaptcha/api.js?render=" +
    encodeURIComponent(siteKey);
  script.async = true;
  script.defer = true;
  script.setAttribute("data-recaptcha-api", "true");
  document.head.appendChild(script);
}

function bindRecaptchaForm(field) {
  var form = field.closest("form");
  if (!form || form.dataset.recaptchaBound === "true") return;

  var siteKey = field.dataset.recaptchaSiteKey;
  var action = field.dataset.recaptchaAction;
  if (!siteKey || !action) return;

  form.dataset.recaptchaBound = "true";

  form.addEventListener("submit", function(event) {
    if (form.dataset.recaptchaReady === "true") return;
    if (typeof grecaptcha === "undefined" || !grecaptcha.execute) return;

    event.preventDefault();
    grecaptcha.ready(function() {
      grecaptcha.execute(siteKey, { action: action }).then(function(token) {
        field.value = token;
        form.dataset.recaptchaReady = "true";
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    });
  });
}

document.addEventListener("turbolinks:load", function() {
  var fields = document.querySelectorAll("[data-recaptcha-site-key]");
  if (!fields.length) return;

  removeRecaptcha();
  loadRecaptchaApi(fields[0].dataset.recaptchaSiteKey);
  fields.forEach(bindRecaptchaForm);
});
